import { takeLatest, all, call, put, select } from "redux-saga/effects";
import {
  updateServico,
  allServicos as allServicosAction,
  resetServico,
  removeArquivos,
  addServico,
} from "./actions";
import types from "./types";
import {api} from "../../../services/api";
import consts from "../../../consts";
import { FormattedDate } from "rsuite/esm/CustomProvider";

export function* allServicos() {
  const { form } = yield select((state) => state.servico);
  try {
    yield put(updateServico({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/servico2/1`);

    yield put(updateServico({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    console.log(res);

    yield put(updateServico({ servicos: res }));
  } catch (error) {
    yield put(updateServico({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addServicos() {
  const { form, servico, components, behavior } = yield select(
    (state) => state.servico
  );

  try {
    yield put(updateServico({ form: { ...form, saving: true } }));
    

    const formData = new FormData();
    formData.append("servico", JSON.stringify({...servico , id: consts.id}));
    formData.append("id", consts.id);
    servico.arquivos.map((arquivo, index) => {
      formData.append(`arquivo_${index}`, arquivo);
    });

    const {data: res}= yield call(api[behavior=== "create"? "post": "put"], behavior=== "create"? "/servico": `/servico/${servico.id}`, formData )

    yield put(updateServico({ form: { ...form, saving: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allServicosAction());
    yield put(updateServico({ components: { ...components, drawer: false } }));
    yield put(resetServico());
  } catch (error) {
    yield put(updateServico({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}

export function* removeServico() {
  const { form, servico, components } = yield select(
    (state) => state.colaborador
  );
  try {
    yield put(updateServico({ form: { ...form, saving: true } }));
    const { data: res } = yield call(
      api.delete,
      `/servicos/${servico.id}`
    );
    yield put(updateServico({ form: { ...form, saving: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allServicosAction());
    yield put(
      updateServico({
        components: { ...components, drawer: false, confirmDelete: false },
      })
    );
    yield put(resetServico());
  } catch (error) {
    yield put(updateServico({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}

export function* removeArquivo({ key }) {
  const { form } = yield select((state) => state.servico);
  try {
    yield put(updateServico({ form: { ...form, saving: true } }));
    const { data: res } = yield call(
      api.post,
      `/servicos/delete-arquivo/`, key
    );
    yield put(updateServico({ form: { ...form, saving: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    
  } catch (error) {
    yield put(updateServico({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}

export function* filterColaboradores() {
  const { form, colaborador } = yield select((state) => state.colaborador);
  try {
    yield put(updateServico({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/filter`, {
      filters: { email: colaborador.email, status: "A" },
    });
    yield put(updateServico({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    if (res.colaboradores.length > 0) {
      yield put(
        updateServico({
          colaborador: res.colaboradores[0],
          form: { ...form, filtering: false, disabled: false },
        })
      );
    } else {
      yield put(updateServico({ form: { ...form, disabled: false } }));
    }
  } catch (error) {
    console.log("fallolu");
    yield put(updateServico({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export default all([
  takeLatest(types.ALL_SERVICOS, allServicos),
  takeLatest(types.ADD_SERVICO, addServicos),
  takeLatest(types.REMOVE_SERVICO, removeServico),
  takeLatest(types.REMOVE_ARQUIVOS, removeArquivo),
  takeLatest(types.FILTER_SERVICO, filterColaboradores),
]);
